//export const API_URL = "http://127.0.0.1:4000";
export const API_URL = "https://api.digiportal.info";
export const CALLBACK_URL = "https%3A%2F%2Fwebhook.digiportal.info%2Fwebhook%2Fzaloauth";
export const ZALO_APP_URL = "https://oauth.zaloapp.com/v4/oa/permission";
export const ADMINS_EMAILS = ["system@digiconnex.vn"];
